import React from "react";

export default function DeletePatientModal({ show, onClose, selectedPatientForDelete, onConfirm }) {
  if (!show || !selectedPatientForDelete) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <h2>Delete Patient</h2>
        <p>Are you sure you want to delete <strong>{selectedPatientForDelete.name}</strong>?</p>
        <p style={{ color: '#ef4444', fontSize: '14px' }}>This action cannot be undone. All associated sessions will also be deleted.</p>
        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button
            className="btn"
            onClick={onConfirm}
            style={{ background: '#ef4444', color: '#fff' }}
          >
            Delete
          </button>
          <button
            className="btn"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
